export default [
    {
        path: '/ainB5ftYO3bdMEPOgXKE',
        children: [
            {
        path: '2Zkj2Qp9ilTn',
        name: 'role-mng',
        meta: {
            title: 'Roles management',
            authRequired: true,
            // acc: ['v1'],
        },
        component: () => import('../views/settings/roles/roles.vue'),
    },
    {
        path: '4cH5QK2LGZQf',
        name: 'newRole',
        meta: {
            title: 'New Role',
            authRequired: true,
            // acc: ['v1'],
        },
        component: () => import('../views/settings/roles/newRole.vue'),
    },
    {
        path: '/01eCxfpVx0aM',
        name: 'role-1',
        meta: {
            title: 'Role',
            authRequired: true,
            // acc: ['v1'],
        },
        component: () => import('../views/settings/roles/role.vue'),
    },
        
        ]
    }
    
   


]